import React from 'react';
import routes, { publicRoutes } from '../../constants/routes';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import authenticationUtils from '../../utils/authenticationUtils';
import { UserRole } from '../../enums';
import browserUtils from '../../utils/browserUtils';
import { Navigate, useLocation } from 'react-router-dom';

const rolesRestrictedForAdminHome = [
  UserRole.CURRENT_PARENT,
  UserRole.CURRENT_STUDENT
];

const AuthGate = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { user } = useSelector((state: RootState) => state.profile);

  const hasUserAccessToAdminHome =
    authenticationUtils.isAuthenticated() &&
    user?.isRetoolUser &&
    !rolesRestrictedForAdminHome.includes(user?.role);

  const isPublicRoute = publicRoutes.includes(location.pathname);

  if (browserUtils.isBrowser() && !hasUserAccessToAdminHome && !isPublicRoute) {
    return <Navigate to={routes.ADMIN_LOGIN} replace />;
  }

  return <>{children}</>;
};

export default AuthGate;
